import { render, staticRenderFns } from "./xszpDetail.vue?vue&type=template&id=71ce88c5&scoped=true&"
import script from "./xszpDetail.vue?vue&type=script&lang=js&"
export * from "./xszpDetail.vue?vue&type=script&lang=js&"
import style0 from "./xszpDetail.vue?vue&type=style&index=0&id=71ce88c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ce88c5",
  null
  
)

export default component.exports